import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RegistryRouting } from './public-registry.route';
import { PublicRegistryComponent } from './public-registry.component';
import {
  PublicRegistryResolverService,
  PublicRegistryRecordResolverService,
} from 'pages/public-registry/public-registry-resolver.service';
import { OrganizationService } from 'services/organization/organization.service';
import { RegistryTableModule } from 'components/registry-table/registry-table.module';
import { HeaderModule } from 'components/header/header.module';
import { PublicRegistryTableModule } from 'pages/public-registry/public-registry-table/public-registry-table.module';

@NgModule({
  declarations: [PublicRegistryComponent],
  providers: [OrganizationService, PublicRegistryResolverService, PublicRegistryRecordResolverService],
  imports: [RouterModule.forChild(RegistryRouting), RegistryTableModule, PublicRegistryTableModule, HeaderModule],
  exports: [RouterModule],
})
export class PublicRegistryModule {}
